export default __webpack_public_path__ + "static/media/Untitled.5f1af186.png";